import RoutesHeader from './RoutesHeader'
import RoutesTabs from './RoutesTabs'

const RoutesBlock = () => {
  return (
    <div className="routes_block">
      <RoutesHeader />
      <RoutesTabs />
    </div>
  )
}

export default RoutesBlock
